import styled from 'styled-components';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  z-index: 99;
  color: white;
  text-align: center;
  font-weight: 300;

  > div:nth-child(1) {
    padding-top: 37px;
    font-size: 20px;
  }
  > div:nth-child(2) {
    font-size: 14px;
    padding-bottom: 33px;
  }
`;

export { Wrapper };



// WEBPACK FOOTER //
// ./src/components/Loader/style.js